import React, { useEffect, useState } from 'react'
import { Form } from "react-router-dom";
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { IWorkSpaceModal } from '../../models/SharedModel';
import { folderNameRegex } from '../../helpers/RegexHelpers';
import Service from '../../services';
import userDark from '../../images/user-dark.png';
import { text_convert_lower } from '../../helpers/GenericHelpers';
import SearchableDropdown from '../../commonfields/SearchableDropdown';
import { IDropdownOptionsModel } from '../../models/CommonFields';


interface IWorkSpaceFormProps {
  setWorkSpace: React.Dispatch<React.SetStateAction<Partial<IWorkSpaceModal> | null>>;
  cancelWorkSpace:Function;
  submitWorkSpace:Function;
  workSpace: Partial<IWorkSpaceModal> | null;
  setSelectedOptions:Function
  selectedOptions:[]
  }

const WorkSpaceForm = (props: IWorkSpaceFormProps) => {

  const [errors, setErrors] = useState<Partial<IWorkSpaceModal>>({});
  const service = new Service();
  const {setWorkSpace, cancelWorkSpace, workSpace, submitWorkSpace,selectedOptions, setSelectedOptions} = props
  // helpers functions
  const handleChange = (value: string, field: string) => {
    setWorkSpace((prev) => ({
      ...(prev ?? {}),
      [field]: value || "",
    }));
  };

 const [userList, setUserList] = useState<any>([])
 useEffect(()=>{
  setSelectedOptions([])
  service.get_list_of_users().then((response:any)=>{
    console.log(response.data)
    setUserList(response?.data?.list_of_users);
  }).catch((error:any)=>{
    console.log(error)
  })
 },[])

  const validateFields = (value: string, field: string) => {
    if (field === "workspace_name") {
      if (!value.match(folderNameRegex)) {
        setErrors((prev) => ({
          ...(prev ?? {}),
          [field]: 'Only alphabets, 0-9, "_" are allowed for Name',
        }));
      } else {
        setErrors((prev) => {
          if (prev && (prev as any)?.[field]) {
            delete (prev as any)?.[field];
            return prev;
          } else return {};
        });
      }
    } 
  }

  const checkErrors = () => {
    const keys = Object.keys(errors);
    if (keys?.length > 0) return true;
    else return false;
  };

  const checkValues = () => (workSpace?.workspace_name && workSpace?.workspace_name ? false : true);

  const handleSelectChange = (event:any) => {
    const selected:any = Array.from(event.target.selectedOptions, (option:any) => option.value);
    setSelectedOptions(selected);
  };

  const displayOptions = (values: any) => {
    const keys = Object.keys(values)
    return values?.map((each:any) => ({
      value: each?.user_id,
      label: text_convert_lower(each?.user_name),
    }))
  }

  const handleUserChange = (values: IDropdownOptionsModel) => {
    setSelectedOptions(values);
  }
  return (
    <div className="project-form">
      <Form>
      <div className="input-row">
          <FormGroup className={`project-input name`}>
            <Label for="workspace_name">Work Space Name<span className='required'>*</span></Label>
            <Input
              id="workspace_name"
              name="workspace_name"
              placeholder="Enter the solution name"
              type="text"
              onChange={(e) => {
                handleChange(e?.target?.value, "workspace_name");
                validateFields(e?.target?.value, "workspace_name");
              }}
              onBlur={(e) => {
                validateFields(e?.target?.value, "workspace_name");
              }}
            />
             {errors?.workspace_name ? (
              <div className="error-field" color="danger">
                {errors?.workspace_name}
              </div>
            ) : (
              <></>
            )}
          </FormGroup>
        </div>
        <div className="input-row">
          <FormGroup className={`project-input type`}>
            {/* <Label for="eproject-type">Select Users<span className='required'>*</span></Label> */}
            <div className='multi-select-users'>
              {selectedOptions?.length<=0 ? <Label for="eproject-type">Select Users<span className='required'>*</span></Label> :''  }
              {selectedOptions?.map((ele:any)=>
              <div className='user-details'>
                <img src={userDark} alt='user'/>
                <div className='text'>{ele?.label}</div>
              </div>)}
            </div>
            <SearchableDropdown
              // value={selectedData?.roles}
              handleChange={handleUserChange}
              options={displayOptions(userList)}
              classNamePrefix='extractedSearch'
              isMulti={true}
              placeholder='select roles'
            />
            {/* <Input type="select" className='map-user-select' name="selectMulti" id="exampleSelectMulti" multiple onChange={handleSelectChange}>
              {userList.map((el:any,index:number)=>(
                 <option key={index} value={el.user_id}><div>{el.user_name}</div><img src={userDark} alt="user" /></option>
              ))}
            </Input> */}
          </FormGroup>
        </div>
        <div className="btns">
          <Button
            className="cancel"
            onClick={() => cancelWorkSpace(workSpace)}
          >
            Cancel
          </Button>
          <Button
            className="submit"
            disabled={checkErrors() || checkValues() || selectedOptions?.length<1}
            onClick={() => submitWorkSpace(workSpace)}
          >
            Submit
          </Button>
        </div>
      </Form>
      </div>
  )
}

export default WorkSpaceForm